<script setup>
import { storeToRefs } from 'pinia'

import MooringPointsTableHeader from '@/components/mooring-points/MooringPointsTableHeader.vue'
import MooringPointsTableRow from '@/components/mooring-points/MooringPointsTableRow.vue'

import { useCalculationStore } from '@/stores/calculation'

import { BERTH_TYPE } from '@/constants/calculationFieldConstants'
import { ISLAND } from '@/components/calculation/calculation.constant'

const props = defineProps({
  items: { type: Array, required: true }
})
const { currentItem: currentCalculation } = storeToRefs(useCalculationStore())
</script>

<template>
  <v-divider />
  <v-table hover density="compact" fixed-header>
    <thead>
      <MooringPointsTableHeader />
    </thead>
    <tbody v-if="items.length">
      <template v-for="(item, index) in items" :key="item.id">
        <MooringPointsTableRow :item="item" :last-row="index === items.length - 1" />
      </template>
    </tbody>
    <tbody v-else>
      <tr>
        <td colspan="999" class="text-center0 pt-3" style="font-size: 13px">
          <template v-if="currentCalculation[BERTH_TYPE] === ISLAND">
            There are no mooring points available, please select
            <v-btn
              class="mx-1 clickable text-none"
              style="cursor: default"
              :elevation="0"
              readonly
              :ripple="false"
              prepend-icon="mdi-refresh"
              color="primary"
              size="x-small"
              variant="elevated"
            >
              Optimise
            </v-btn>
            to generate the mooring points or add them manually.
          </template>
          <template v-else>
            There are no mooring points available, please select
            <v-btn
              class="mx-1 clickable text-none"
              style="cursor: default"
              :elevation="0"
              readonly
              :ripple="false"
              prepend-icon="mdi-plus-box-multiple"
              color="primary"
              size="x-small"
              variant="elevated"
            >
              Generate
            </v-btn>
            in the input tab, to generate the mooring points or add them manually.
          </template>
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<style scoped></style>
